<template>
  <div>
    <h2 class="header-title">
      参赛者管理
    </h2>
    <el-divider></el-divider>
    <!-- <el-radio-group v-model="radio1">
      <el-radio-button label="参赛者"></el-radio-button>
      <el-radio-button label="退出记录"></el-radio-button>
      <el-badge :value="12" class="item">
        <el-radio-button label="报名记录"></el-radio-button>
      </el-badge>
    </el-radio-group> -->

    <div class="header_block">
      <el-button @click="change('course-member')">参赛者</el-button>
      <el-button type="primary">退出记录</el-button>
      <el-button @click="change('course-member-check')" v-if="checkNumber <= 0">报名记录</el-button>
      <el-badge :value="checkNumber" class="item" v-else>
        <el-button @click="change('course-member-check')">报名记录</el-button>
      </el-badge>
    </div>
    <div class="content">
      <div class="search_wrap">
        <el-input v-model="keyword" placeholder="请输入用户名或邮箱" @keyup.enter.native="search()"></el-input>
        <el-button type="primary" @click="search()">搜索</el-button>
      </div>
      <el-table :data="list" stripe style="width: 100%" v-if="list.length > 0">
        <el-table-column label="参赛者">
          <template slot-scope="scope">
            <img class="avatar" src="@/assets/imgs/avatar.png" alt="" />
            <span class="name">{{ scope.row.user.nickname }}</span>
          </template>
        </el-table-column>
        <el-table-column label="加入时间">
          <template slot-scope="scope">
            {{ common.date("Y-m-d H:i", scope.row.order.createdTime) }}
          </template>
        </el-table-column>
        <el-table-column label="退出时间">
          <template slot-scope="scope">
            {{ common.date("Y-m-d H:i", scope.row.createdTime) }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @current-change="pageChange" background layout="total, prev, pager, next" :total="paginator.itemCount" :page-size="20" v-if="paginator" hide-on-single-page>
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getCourseMemberQuitList } from "@/api/course";
export default {
  data() {
    return {
      keyword: "",
      list: [],
      page: 1,
      users: [],
      checkNumber: 0,
      paginator: null,
    };
  },
  methods: {
    handle() {
      var params = {
        keyword: this.keyword,
        page: this.page,
      };
      getCourseMemberQuitList(this.$route.params.competitionId, params).then(
        response => {

          this.list = response.data.refunds;
          this.paginator = response.data.paginator;
          this.checkNumber = response.data.checkCount;
        }
      );
    },
    pageChange(val) {
      this.page = val;
      this.handle();
    },
    change(route) {
      this.$router.push({
        name: route,
        params: { competitionId: this.$route.params.competitionId }
      });
    },
    search() {
      this.page = "1";
      this.handle();
    },
    delete() { }
  },
  created() {
    this.handle();
    // this.checkNumber = this.$attrs.checkNumber;
  }
};
</script>

<style scoped>
.header-title {
  position: relative;
  /* font-size: 16px; */
  /* padding: 10px 0; */
  /* line-height: 30px; */
  background: #fff;
}
.el-badge {
  vertical-align: baseline;
}
.el-badge .el-button {
  margin-left: 10px;
}
.content {
  padding: 10px 0;
}
.content .el-input {
  width: 200px;
  margin-right: 10px;
}
.avatar {
  border-radius: 50%;
  width: 40px !important;
  height: 40px !important;
}
.cell {
  display: flex;
}
.name {
  margin-left: 10px;
  line-height: 44px;
}
.search_wrap {
  background-color: #fafafa;
  border: 1px solid #f5f5f5;
  padding: 9px;
  border-radius: 2px;
}
.header_block .el-button--default {
  border: 0;
}
</style>
